import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useSunbitEstimation = (options = {}) => {
  const res = useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.sunbit.getEstimation(), dto),
    { ...options },
  );

  return {
    ...res,
    data: {
      valid: res?.data?.data?.[0]?.valid || false,
      monthlyAmount: res?.data?.data?.[0]?.monthlyAmount || 0,
    },
  };
};
